import React from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { initSentry } from './lib/sentry.js';
import './styles/index.css';
import './styles/daily-mission.css';
import './styles/log.css';
import './styles/tokens.css';
import './styles/dashboard.css';
import './styles/bottom-nav.css';
import './styles/landing.css';
// v2 design-system tokens. Imported last so they win over the v1 ladder in
// tokens.css at equal specificity (see DESIGN.md 2026-08-01 decision).
import './styles/v2-tokens.css';
import './styles/admin.css';

// Initialize Sentry (no-op without VITE_SENTRY_DSN) before the root renders so
// the first render is already covered.
void initSentry();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
